module.exports = __webpack_public_path__ + "static/media/fintechgalaxy.1d5d67d8.png";